import { Twitter, Instagram, Facebook } from 'lucide-react';
import { Link } from 'react-router-dom';
import '../../../styles/LandingIntegrated.css';

const Footer = () => {
  return (
    <footer className="li-footer">
      <div className="li-container">
        <div className="li-footer-grid">
          <div className="li-footer-brand">
            <div className="li-flex li-items-center li-gap-3" style={{ marginBottom: '1.5rem' }}>
              <img src="/Images/trueExams_logo.png" alt="trueExams Logo" className="li-nav-logo" style={{ height: '2rem' }} />
              {/* <span style={{ fontSize: '1.25rem', fontWeight: 700, letterSpacing: '-0.025em', color: '#111827' }}>trueExams</span> */}
            </div>
            <p style={{ color: '#6b7280', maxWidth: '24rem', marginBottom: '1.5rem' }}>
              Revolutionizing the way competitive exams are conducted and evaluated. Join the hybrid learning movement today.
            </p>
            <div className="li-flex li-gap-4">
              <a href="#" className="li-social-icon">
                <Twitter size={20} />
              </a>
              <a href="#" className="li-social-icon">
                <Instagram size={20} />
              </a>
              <a href="#" className="li-social-icon">
                <Facebook size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h4 style={{ fontWeight: 700, marginBottom: '1.5rem' }}>Quick Links</h4>
            <ul className="li-footer-links">
              <li><Link to="/" className="li-footer-link">Home</Link></li>
              <li><a href="/#features" className="li-footer-link">Features</a></li>
              <li><a href="/#roles" className="li-footer-link">Institutions</a></li>
              <li><a href="/#pricing" className="li-footer-link">Pricing</a></li>
            </ul>
          </div>

          <div>
            <h4 style={{ fontWeight: 700, marginBottom: '1.5rem' }}>Support</h4>
            <ul className="li-footer-links">
              <li><Link to="/privacy" className="li-footer-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="li-footer-link">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        
        <div style={{ paddingTop: '2rem', borderTop: '1px solid #f3f4f6', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', color: '#9ca3af', fontSize: '0.875rem' }}>
          <p>&copy; 2026 trueExams Product Team. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
